// extracted by mini-css-extract-plugin
export var activeFilterButton = "_o6-c";
export var backButton = "_o6-4";
export var backIcon = "_o6-5";
export var chevronShortcut = "_o6-6";
export var container = "_o6-1";
export var editor = "_o6-8";
export var editorWrapper = "_o6-7";
export var prefix = "_o6-2";
export var searchIcon = "_o6-3";
export var suffix = "_o6-9";
export var suffixContent = "_o6-a";
export var suffixText = "_o6-b";
export var wrapper = "_o6-0";